
/**
* @constructor
* Implements a minimal drop-down navigation menu with hamburger menu on mobile / tablet
*
* @param {Element} menu The menu element.
*/
export default function A11yMenu(menu) {
	// Define value for keycodes
	const VK_ESC = 27;

	this.container = menu.parentElement; // The nav element
	this.trigger = this.container.querySelector('.a11y-nav-trigger'); // the hamburger button
	this.currentMenuItem = false;
	this.firstFocusableElement = "";
	this.lastFocusableElement = "";
	this.nonModalAreas = document.querySelectorAll("body > *:not([role='banner']), .siteTitle");

	this.media = window.matchMedia('(max-width:64em)');
	this.media.addEventListener('change',  (e) => {
		this.checkIfMobileNav(e);
	});

	// Initialisation
	this.init = () => {
		this.menuSetup();
	};

	// Open / Close main Nav
	this.toggleNavContainer = () => {

		if (this.trigger.getAttribute('aria-expanded') === 'false') {

			menu.style.transition = "";

			document.body.setAttribute('data-burger-menu-status', 'opened');
			this.trigger.setAttribute('aria-expanded', true);
			menu.removeAttribute('aria-hidden');
			
			this.nonModalAreas.forEach((element) => {
				element.inert = true;
				element.setAttribute("aria-hidden", "true");
			});

		} else {
			this.nonModalAreas.forEach((element) => {
				element.inert = false;
				element.removeAttribute("aria-hidden");
			});


			this.trigger.setAttribute('aria-expanded', false);
			menu.setAttribute('aria-hidden', true);
			document.body.setAttribute('data-burger-menu-status', 'closed');

			setTimeout(() => {
				menu.style.transition = "none";
			}, 500);
		}

		this.trigger.focus();

	};

	this.keyboardManager = (e) => {

		if (!this.isEltHidden(this.trigger)) {
			// Check for TAB key press
			if (e.keyCode === 9) {

				// SHIFT + TAB
				if (e.shiftKey) {
					if (document.activeElement === this.firstFocusableElement) {
						e.preventDefault();
						this.lastFocusableElement.focus();
					}

					// TAB
				} else {
					if (document.activeElement === this.lastFocusableElement) {
						e.preventDefault();
						this.firstFocusableElement.focus();
					}
				}
			}

			// ESCAPE
			if (e.keyCode === VK_ESC) {
				this.closeNav();
			}
		}

	};

	this.closeNav = () => {

		this.toggleNavContainer();
		this.trigger.focus();
		
	};


	// Modify Menu Markup & Bind Listeners
	this.menuSetup = () => {

		this.checkIfMobileNav(this.media);
		this.container.classList.remove('no-js');
		this.container.classList.add('with-js');

		// Check if menu is hidden and trigger visible : then add Aria to the menu
		if (this.isEltHidden(menu) && !document.body.classList.contains('is-animating')) {
			this.setUpNavContainerAria();
		}
		// Bind event listener
		this.trigger.addEventListener('click', this.toggleNavContainer);

		// Setup focus trap
		const focusableElements = this.container.querySelectorAll('a, button');
		this.firstFocusableElement = focusableElements[0];
		this.lastFocusableElement = focusableElements[focusableElements.length - 1];

		// Bind keyboard listener to nav
		this.container.addEventListener('keydown', this.keyboardManager.bind(this));

		
	};

	this.setUpNavContainerAria = () => {

		this.trigger.setAttribute('aria-expanded', false);
		menu.setAttribute('aria-hidden', true);

	};

	this.checkIfMobileNav = (e) => {
		if (e.matches) {
			// Switch to mobile menu
			this.trigger.setAttribute('aria-expanded', false);
			menu.setAttribute('aria-hidden', true);
			menu.setAttribute('role', 'dialog');
			menu.setAttribute('aria-labelledby', 'nav-toggle');
			menu.style.transition = "none";

		} else {

			// Switch to desktop
			this.trigger.setAttribute('aria-expanded', true);
			menu.removeAttribute('aria-hidden');
			menu.removeAttribute('role');
			menu.removeAttribute('aria-labelledby');

		}
	};

	// Private functions

	this.isEltHidden = (elem) => {

		const styles = window.getComputedStyle(elem);
		return (styles.display === 'none' || styles.visibility === 'hidden');

	};


}
